import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null=checking, false=none, obj=portal user
  const [l1, setL1] = useState(null);        // null=checking, bool
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/eadmin/l1-status");
      setL1(!!r.data.emergent_admin_authenticated);
    } catch { setL1(false); }
    const token = localStorage.getItem("qaig_token");
    if (!token) { setUser(false); }
    else {
      try { const r = await api.get("/auth/me"); setUser((p) => (p && p.id ? p : r.data)); }
      catch { setUser((p) => (p && p.id ? p : false)); }
    }
    setReady(true);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("qaig_token", data.token);
    setUser(data); setL1(true);
    return data;
  };

  const logout = async () => {
    try { await api.post("/eadmin/logout"); } catch {}
    localStorage.removeItem("qaig_token");
    setUser(false); setL1(false);
  };

  const hasPerm = (p) => user && (user.permissions || []).includes(p);
  const isAdmin = user && user.role === "Administrator";

  return <AuthContext.Provider value={{ user, l1, ready, setL1, setUser, refresh, login, logout, hasPerm, isAdmin }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
